<template>
    <div id="Content" v-if="examinations">
        <analysis-method :completedExaminations="examinationsInSir.length" v-if="!accountTypeIsPro"></analysis-method>

        <section class="box-data">
            <div>
                <h3 class="title-content">
                    {{ $t('MEDICAL_RESULTS') }}
                </h3>

                <!--FILTERS-->
                <div class="row">
                    <div class="search__wrapper col-xs-12 mb-3">
                        <div class="is-relative">
                            <el-date-picker id="datePicker1" v-model="dateFrom" type="date" :placeholder="$t('FROM')">
                            </el-date-picker>
                            <label for="datePicker1" class="d-inline">
                                <img class="date-icon" src="../../../assets/images/icons/ico-calendar.png" />
                            </label>
                        </div>
                        <div class="is-relative">
                            <el-date-picker id="datePicker2" v-model="dateTo" type="date" :placeholder="$t('TO')">
                            </el-date-picker>
                            <label for="datePicker2" class="d-inline">
                                <img class="date-icon" src="../../../assets/images/icons/ico-calendar.png" />
                            </label>
                        </div>
                        <v-radio-group v-model="isRead" class="input-date-wrapper">
                            <v-radio :label="$t('READ')" color="main-color" value="read"></v-radio>
                        </v-radio-group>
                        <v-radio-group v-model="isRead" class="input-date-wrapper">
                            <v-radio :label="$t('UNREAD')" color="main-color" value="unread"></v-radio>
                        </v-radio-group>
                        <v-radio-group v-model="isRead" class="input-date-wrapper">
                            <v-radio :label="$t('ALL')" color="main-color" @click.native="clearFilters" value="all">
                            </v-radio>
                        </v-radio-group>
                    </div>
                </div>
                <div class="row mt-2" v-if="accountTypeIsPro">
                    <div class="col-xs-12 col-sm-6 col-sm-offset-6">
                        <input
                            class="text-input -white-input-border"
                            style="border-color: #cdc9c6;"
                            :placeholder="$t('BRASTER_PRO_EXAMINATION_ID')"
                            v-model="additionalDataSearch"
                        />
                    </div>
                </div>
                <div class="row" v-if="showCompleteExaminationForm">
                    <div class="col-xs-12">
                        <external-documentation-data-form
                            v-if="proExternalDocumentation"
                            @hideForm="showCompleteExaminationForm = false"
                            @reloadExaminations="examinationsReloadingCounter = examinationsReloadingCounter + 1"
                            :examinationId="examinationThatNeedsToBeCompleted.id"
                        >
                        </external-documentation-data-form>
                        <examination-data-form
                            v-else
                            @hideForm="showCompleteExaminationForm = false"
                            @reloadExaminations="examinationsReloadingCounter = examinationsReloadingCounter + 1"
                            :examinationId="examinationThatNeedsToBeCompleted.id"
                        >
                        </examination-data-form>
                    </div>
                </div>
                <div class="row mt-4">
                    <result-item
                        class="col-xs-12"
                        v-for="examination in filteredItemsOnCurrentPage"
                        :key="examination.id"
                        :examination="examination"
                        @click="showMedicalResult(examination)"
                    />
                    <div
                        class="col-xs-12 text-xs-center mb-3 mt-3"
                        style="color: #706C69;"
                        v-if="!filteredItems.length"
                    >
                        {{ $t('EMPTY_LIST') }}
                    </div>
                    <div class="col-xs-12 text-xs-center" v-if="numberOfPages > 1">
                        <v-pagination
                            :length="numberOfPages"
                            :total-visible="numberOfTotalVisiblePages"
                            prev-icon="arrow_back"
                            next-icon="arrow_forward"
                            v-model="currentlyDisplayedPage"
                        ></v-pagination>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import Vue from 'vue';
import { DatePicker } from 'element-ui';
import { mapActions, mapGetters, mapState } from 'vuex';
import AnalysisMethod from './analysis-method.vue';
import ResultItem from './result-item.vue';
import ExaminationDataForm from './examination-data-form.vue';
import ExternalDocumentationDataForm from './external-documentation-data-form.vue';
import StaticMap from 'vue-static-map';
import { examinationCanBeDisplayed } from './../../../assets/js/examinationUtils';
import { examinationNeedsToComplete } from '../../../assets/js/examinationUtils';

Vue.use(DatePicker);

export default {
    data() {
        return {
            currentlyDisplayedPage: 1,
            ex7: '',
            hideDetails: true,
            isRead: 'all',
            dateFrom: '',
            dateTo: '',
            numberOfExaminationsOnOnePage: 9,
            additionalDataSearch: '',
            showCompleteExaminationForm: false,
            examinationThatNeedsToBeCompleted: null,
            examinationsReloadingCounter: 0,
        };
    },
    computed: {
        ...mapState(['examinations']),
        ...mapGetters(['accountTypeIsPro', 'proExternalDocumentation']),
        examinationsInSir() {
            return this.examinations.filter(examination => examination.insir);
        },
        filteredItems() {
            // Go to first page every time filter is changed
            this.currentlyDisplayedPage = 1;
            return this.examinations.filter(
                el => this.matchesReadStatus(el) && this.matchesDateRange(el) && this.matchesAdditionalDataSearch(el),
            );
        },
        numberOfPages() {
            return Math.ceil(this.filteredItems.length / this.numberOfExaminationsOnOnePage);
        },
        numberOfTotalVisiblePages() {
            return this.numberOfPages < 10 ? this.numberOfPages : 10;
        },
        filteredItemsOnCurrentPage() {
            return this.filteredItems.slice(
                (this.currentlyDisplayedPage - 1) * this.numberOfExaminationsOnOnePage,
                this.currentlyDisplayedPage * this.numberOfExaminationsOnOnePage,
            );
        },
    },
    methods: {
        ...mapActions(['fetchExaminations']),
        matchesDateRange(el) {
            if (!this.dateFrom || !this.dateTo) {
                return true;
            }
            const startDate = new Date(this.dateFrom);
            const endDate = new Date(this.dateTo);
            const elDate = new Date(el.isoDate).setHours(0, 0, 0, 0);
            return startDate <= elDate && elDate <= endDate;
        },
        matchesReadStatus(el) {
            switch (this.isRead) {
                case 'all':
                    return true;
                case 'read':
                    return el.read === true;
                case 'unread':
                    return el.read === false && examinationCanBeDisplayed(el);
            }
        },
        matchesAdditionalDataSearch(el) {
            const additionalData = el.additionalData ? el.additionalData.toLowerCase() : '';
            const search = this.additionalDataSearch.toLowerCase();
            return additionalData.indexOf(search) > -1;
        },
        clearFilters() {
            this.isRead = 'all';
            this.dateFrom = '';
            this.dateTo = '';
        },
        showMedicalResult(examination) {
            if (examinationNeedsToComplete(examination)) {
                this.examinationThatNeedsToBeCompleted = examination;
                this.showCompleteExaminationForm = true;
            } else if (examinationCanBeDisplayed(examination)) {
                this.$router.push({ name: 'szczegoly-badania', params: { id: examination.id } });
                this.$scrollTo('#Content', 500, { offset: -50 });
            }
        },
        examinationCanBeDisplayed,
        examinationNeedsToComplete,
    },
    components: {
        ResultItem,
        AnalysisMethod,
        ExaminationDataForm,
        ExternalDocumentationDataForm,
        StaticMap,
        eLDatePicker: DatePicker,
    },
    watch: {
        $route() {
            Vvm.$gmapDefaultResizeBus.$emit('resize');
        },
        examinationsReloadingCounter: {
            handler: 'fetchExaminations',
            immediate: true,
        },
    },
};
</script>

<style scoped>
.input-date-wrapper {
    display: inline-block;
    margin-right: 20px;
    max-width: 116px;
}

.input-date {
    background: url('../../../assets/images/calendar.png') no-repeat 85% center;
    background-size: 15px;
}

.search__wrapper {
    align-items: baseline;
    display: flex;
}

@media (max-width: 1019px) {
    .search__wrapper {
        flex-direction: row;
        flex-wrap: wrap;
    }

    .search__wrapper > div {
        flex: 1 1 auto;
    }

    .search__wrapper .el-date-editor .el-input__inner {
        width: 100%;
    }

    .app-btn {
        margin-left: auto;
    }
}

.pagination {
    display: block !important;
    text-align: center !important;
}
</style>



// WEBPACK FOOTER //
// medical-results.vue?5f4a0778